// Static utility for Heap tracking
export class HeapUtils {
  static track(eventName: string, properties: { [name: string]: any } = {}): void {
    if (window.heap) {
      window.heap.track(eventName, properties);
    }
  }

  static identify(id: string): void {
    if (window.heap) {
      window.heap.identify(id);
    }
  }

  static addUserProperties(properties: { [name: string]: any }): void {
    if (window.heap) {
      window.heap.addUserProperties(properties);
    }
  }
}
